function PlantDetailHeader({
  impianto,
  statoImpianto,
  getNomeCliente,
  primaryButtonStyle,
  secondaryButtonStyle,
  onNuovoIntervento,
  onModificaImpianto,
  onNuovoDocumento,
  onOpenCustomer,
}) {
  const utenteCorrente = JSON.parse(
    localStorage.getItem("utenteCorrente")
  );

  const isViewer = utenteCorrente?.role === "viewer";

  const stato = statoImpianto || {
    label: "Non disponibile",
    color: "#334155",
    background: "#e2e8f0",
    description: "Stato impianto non calcolato.",
  };

  const infoCardStyle = {
    background: "#f8fbff",
    borderRadius: "12px",
    padding: "14px",
    border: "1px solid #e2e8f0",
  };

  const infoLabelStyle = {
    color: "#64748b",
    fontSize: "13px",
    marginBottom: "4px",
  };

  const handleAction = (callback) => {
    if (callback) {
      callback();

      setTimeout(() => {
        const target = document.getElementById("plant-action-area");
        if (target) {
          target.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  };

  const getCustomerId = () => {
    return (
      impianto?.customer_id ||
      impianto?.customer?.id ||
      impianto?.client_id ||
      null
    );
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: "16px",
          marginBottom: "24px",
        }}
      >
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              flexWrap: "wrap",
              marginBottom: "8px",
            }}
          >
            <h1
              style={{
                color: "#173a63",
                margin: 0,
                fontSize: "34px",
              }}
            >
              {impianto.plant_type || "Impianto"}
            </h1>

            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                padding: "6px 12px",
                borderRadius: "999px",
                background: stato.background,
                color: stato.color,
                fontSize: "13px",
                fontWeight: 800,
              }}
            >
              {stato.label}
            </span>
          </div>

          <div
  style={{
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
    marginBottom: "10px",
    color: "#64748b",
    fontSize: "15px",
    fontWeight: 500,
  }}
>
  <span>{getNomeCliente(impianto)}</span>

<span>•</span>

<span>{impianto.plant_type || "—"}</span>

<span>•</span>

<span>{impianto.brand || "—"}</span>

<span>•</span>

<span>
  Mat. {impianto.serial_number || "—"}
</span>
</div>

<p style={{ color: "#4b5563", margin: 0, lineHeight: "1.5" }}>
  Documentazione tecnica, manutenzioni e storico attività
</p>

<p
  style={{
    color: "#64748b",
    marginTop: "6px",
    marginBottom: 0,
    fontSize: "14px",
    lineHeight: "1.5",
    maxWidth: "720px",
  }}
>
  {stato.description}
</p>
        </div>

        <div
          style={{
            display: "flex",
            gap: "10px",
            flexWrap: "wrap",
            justifyContent: "flex-end",
          }}
        >
          {!isViewer && (
            <button
              className="btn btn-primary"
              onClick={() => handleAction(onNuovoIntervento)}
              style={primaryButtonStyle}
            >
              + Nuovo intervento
            </button>
          )}

          {!isViewer && (
            <button
              className="btn btn-secondary"
              onClick={() => handleAction(onModificaImpianto)}
              style={secondaryButtonStyle}
            >
              Modifica impianto
            </button>
          )}

          {!isViewer && (
            <button
              className="btn btn-secondary"
              onClick={() => handleAction(onNuovoDocumento)}
              style={secondaryButtonStyle}
            >
              Carica documento
            </button>
          )}
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
          gap: "14px",
          marginBottom: "28px",
        }}
      >
        <div style={infoCardStyle}>
          <div style={infoLabelStyle}>Cliente</div>

          <strong
            onClick={() => {
              const customerId = getCustomerId();

              if (customerId && onOpenCustomer) {
                onOpenCustomer(customerId);
              }
            }}
            style={{
              color: "#173a63",
              cursor: onOpenCustomer ? "pointer" : "default",
              textDecoration: onOpenCustomer ? "underline" : "none",
            }}
            title={onOpenCustomer ? "Apri scheda cliente" : ""}
          >
            {getNomeCliente(impianto)}
          </strong>
        </div>

        <div style={infoCardStyle}>
  <div style={infoLabelStyle}>Settore</div>
  <strong>{impianto.sector || "—"}</strong>
</div>

<div style={infoCardStyle}>
  <div style={infoLabelStyle}>Categoria</div>
  <strong>{impianto.category || "—"}</strong>
</div>

<div style={infoCardStyle}>
  <div style={infoLabelStyle}>Tipologia</div>
  <strong>{impianto.plant_type || "—"}</strong>
</div>

<div style={infoCardStyle}>
  <div style={infoLabelStyle}>Marca</div>
  <strong>{impianto.brand || "—"}</strong>
</div>

        <div style={infoCardStyle}>
          <div style={infoLabelStyle}>Modello</div>
          <strong>{impianto.model || "—"}</strong>
        </div>

        <div style={infoCardStyle}>
          <div style={infoLabelStyle}>Matricola</div>
          <strong>{impianto.serial_number || "—"}</strong>
        </div>
      </div>
    </>
  );
}

export default PlantDetailHeader;